export default function isElementInViewport() {
  const observer = new IntersectionObserver((entries) =>
    entries
      .filter((_) => _.isIntersecting)
      .forEach((_) => _.target.classList.add('cm4all-theme-fadeIn--visible'))
  );
  document
    .querySelectorAll('.cm4all-theme-js-fadeIn')
    .forEach((_) => observer.observe(_));
}
